module.exports = __webpack_public_path__ + "static/media/Hydraulics_HydraulicCylinder_Xparent.3edd0450.png";